import { inheritsLoose as _inheritsLoose } from './_virtual/_rollupPluginBabelHelpers.js';
import PropertyList from './PropertyList/index.js';
import { ThemeBlockBackgroundType } from './CompoundedProperties/BlockBackgroundType.js';
import { ThemeBlockShadowStyle } from './CompoundedProperties/BlockShadowStyle.js';
import { ThemePageBackgroundType } from './CompoundedProperties/PageBackgroundType.js';
import { ThemePageContrastColor } from './CompoundedProperties/PageContrastColor.js';
import { ThemeBlockBackgroundValue } from './Properties/BlockBackgroundValue.js';
import { ThemeBlockContrastColor } from './CompoundedProperties/BlockContrastColor.js';
import { ThemeBlockBorderRadius } from './Properties/BlockBorderRadius.js';
import { ThemeBlockBorderStyle } from './Properties/BlockBorderStyle.js';
import { ThemeBlockBorderType } from './Properties/BlockBorderType.js';
import { ThemeBlockBorderValue } from './Properties/BlockBorderValue.js';
import { ThemeBlockBorderWidth } from './Properties/BlockBorderWidth.js';
import { ThemeBlockShadowType } from './Properties/BlockShadowType.js';
import { ThemeBlockShadowValue } from './Properties/BlockShadowValue.js';
import { ThemePageBackgroundValue } from './Properties/PageBackgroundValue.js';
import { ThemePageFontBody } from './Properties/PageFontBody.js';
import { ThemePageFontHeading } from './Properties/PageFontHeading.js';
import { ThemePageButtonContrastColor } from './CompoundedProperties/PageButtonContrastColor.js';
import { ThemeBlockButtonContrastColor } from './CompoundedProperties/BlockButtonContrastColor.js';

/**
 * Theme class
 * @class Theme
 * @extends PropertyList
 * @classdesc Theme class
 * @property {string} id - Theme id
 */
var Theme = /*#__PURE__*/function (_PropertyList) {
  _inheritsLoose(Theme, _PropertyList);
  function Theme(id) {
    // console.log('enchilada value ThemePagetextvalue', ThemePageTextValue.getAll())
    return _PropertyList.call(this, {
      id: id,
      type: 'theme',
      properties: [ThemeBlockBackgroundValue, ThemeBlockBorderRadius, ThemeBlockBorderStyle, ThemeBlockBorderType, ThemeBlockBorderValue, ThemeBlockBorderWidth, ThemeBlockShadowType, ThemeBlockShadowValue, ThemePageFontBody, ThemePageFontHeading, ThemePageBackgroundValue, ThemeBlockBackgroundType, ThemeBlockShadowStyle, ThemePageBackgroundType, ThemePageContrastColor, ThemeBlockContrastColor, ThemePageButtonContrastColor, ThemeBlockButtonContrastColor]
    }) || this;
  }
  return Theme;
}(PropertyList);

export { Theme as default };
//# sourceMappingURL=Theme.js.map
